import { render, staticRenderFns } from "./filtered.vue?vue&type=template&id=0f9a7fda&scoped=true&lang=pug&"
import script from "./filtered.vue?vue&type=script&lang=js&"
export * from "./filtered.vue?vue&type=script&lang=js&"
import style0 from "./filtered.vue?vue&type=style&index=0&id=0f9a7fda&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f9a7fda",
  null
  
)

/* custom blocks */
import block0 from "./filtered.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {WidgetsFiltersMobileNav: require('/home/ubuntu/nuxt/bonkers/releases/20230602131631/components/widgets/filters/mobile-nav.vue').default,WidgetsFiltersMobileApply: require('/home/ubuntu/nuxt/bonkers/releases/20230602131631/components/widgets/filters/mobile-apply.vue').default})
